import { render } from "./VeelgesteldeVragen.vue?vue&type=template&id=3db43954&scoped=true"
import script from "./VeelgesteldeVragen.vue?vue&type=script&lang=js"
export * from "./VeelgesteldeVragen.vue?vue&type=script&lang=js"

import "./VeelgesteldeVragen.vue?vue&type=style&index=0&id=3db43954&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mraha\\Pictures\\tandzorggestel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3db43954"]])

export default __exports__